import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from '../Button/Button';
import { Flex } from '../Box/Box';
import Spinner from '../Spinner/Spinner';
import Text from '../Text/Text';

const ProcessingButton = styled(Button)`
  opacity: ${props => (props.isProcessing ? 0.4 : 1)};
`;

class ButtonAsync extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
      .isRequired,
    isProcessing: PropTypes.bool
  };

  static defaultProps = {
    isProcessing: false
  };

  handleClick = () => {
    if (!this.props.isProcessing) {
      this.props.onClick();
    }
  };

  render() {
    return (
      <ProcessingButton {...this.props} onClick={this.handleClick}>
        {this.props.isProcessing ? (
          <Flex align="center">
            <Spinner width="24px" height="24px" mr="7px" />
            <Text>Поиск...</Text>
          </Flex>
        ) : (
          this.props.children
        )}
      </ProcessingButton>
    );
  }
}

export default ButtonAsync;



// WEBPACK FOOTER //
// ./src/components/units/ButtonAsync/ButtonAsync.js